export enum AlternativeAddressTitleType {
  Ms = 1,
  Mr = 2,
  Company = 3,
  MrAndMrs = 4,
}
